import { useRuntimeTranslation } from "../../../../hooks/useLoadI18nNamespaces";
import { WEB_V2_POSTING_LOCALIZATION_NAMESPACES } from "../../../../methods/getRouteLocalizationNamespaces";

export const useCompactLoadPostingTranslation = () => useRuntimeTranslation(WEB_V2_POSTING_LOCALIZATION_NAMESPACES);

export default useCompactLoadPostingTranslation;
